/* eslint-disable no-console -- dev-only feedback for background hull stability HTTP result */
/**
 * Triggers hull stability scoring (POST /api/hull-stability-session).
 * Used after upload and from the coach dashboard Recompute control.
 */

export function getHullStabilitySessionUrl(): string {
  const isLocalhost =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  return isLocalhost
    ? 'http://localhost:3001/api/hull-stability-session'
    : '/api/hull-stability-session';
}

export type HullStabilitySessionResult =
  | { ok: true; cleanCount: number; rowsWritten: number }
  | { ok: false; message: string };

export async function requestHullStabilitySession(
  sessionId: string,
  accessToken?: string | null
): Promise<HullStabilitySessionResult> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  try {
    const response = await fetch(getHullStabilitySessionUrl(), {
      method: 'POST',
      headers,
      body: JSON.stringify({ sessionId }),
    });

    if (!response.ok) {
      const text = await response.text();
      let message = text.slice(0, 200);
      try {
        const parsed = JSON.parse(text) as { error?: string };
        if (parsed.error) message = parsed.error;
      } catch {
        // use raw text slice
      }
      return { ok: false, message: message || `Scoring failed (${response.status})` };
    }

    const body = (await response.json()) as {
      ok?: boolean;
      cleanCount?: number;
      rowsWritten?: number;
    };

    if (body?.ok && body.rowsWritten != null && body.cleanCount != null) {
      return {
        ok: true,
        cleanCount: body.cleanCount,
        rowsWritten: body.rowsWritten,
      };
    }

    return { ok: false, message: 'Unexpected scoring response' };
  } catch (err) {
    const message = err instanceof Error ? err.message : 'Scoring request failed';
    return { ok: false, message };
  }
}

/** Fire-and-forget after upload (same endpoint as dashboard Recompute). */
export function requestHullStabilityAfterUpload(
  sessionId: string,
  accessToken?: string | null
): void {
  void requestHullStabilitySession(sessionId, accessToken)
    .then((result) => {
      if (result.ok === true) {
        console.log(
          '[upload] Background hull stability OK',
          'rows=',
          result.rowsWritten,
          'clean=',
          result.cleanCount
        );
      } else {
        console.warn('[upload] Background hull stability failed:', result.message);
      }
    })
    .catch((err) => {
      console.warn('[upload] Background hull stability request failed:', err);
    });
}
